// Committee data is organized as terms (see committeeTerms at the bottom).
// To add a new committee term: define its members array, then prepend an
// entry to committeeTerms with current: true and set the old term's
// current flag to false. The About page timeline renders terms in order,
// expanding the current one and folding the rest.

// Committee term (2026-2028)
const committee2026Members = [
  {
    id: 1,
    name: "Brandon Shen",
    position: {
      en: "Board Member",
      zh: "委员会成员"
    },
    image: "/Brandon Shen.png"
  },
  {
    id: 2,
    name: "Shawn Tian",
    position: {
      en: "Board Member",
      zh: "委员会成员"
    },
    image: "/Shawn Tian.png"
  },
  {
    id: 3,
    name: "Ciping Wu",
    position: {
      en: "Board Member",
      zh: "委员会成员"
    },
    image: "/Ciping Wu.png"
  },
  {
    id: 4,
    name: "Nian Zhao",
    position: {
      en: "Board Member",
      zh: "委员会成员"
    },
    image: "/Nian Zhao.png"
  },
  {
    id: 5,
    name: "Tiffany Qiu",
    position: {
      en: "Board Member",
      zh: "委员会成员"
    },
    image: "/Tiffany Qiu.png"
  },
  {
    id: 6,
    name: "ChengCheng Zhao",
    position: {
      en: "Board Member",
      zh: "委员会成员"
    },
    image: "/Chengcheng Zhao.png"
  },
  {
    id: 7,
    name: "Ruicong Ni",
    position: {
      en: "Board Member",
      zh: "创始人，委员会成员"
    },
    image: "/Ruicong Ni.png"
  },
  {
    id: 8,
    name: "Miles Guo",
    position: {
      en: "Software Engineer",
      zh: "软件工程师"
    },
    image: "/Miles Guo.png"
  },
  {
    id: 9,
    name: "Cheng Chen",
    position: {
      en: "Committee Observer",
      zh: "观察员"
    },
    image: "/Cheng Chen.png"
  },
  {
    id: 10,
    name: "Caroline Wang",
    position: {
      en: "Committee Observer",
      zh: "观察员"
    },
    image: "/Caroline Wang.png"
  }
];

// Past committee term (2024-2026)
const committee2024Members = [
  {
    id: 101,
    name: "Junxiao Yi",
    position: {
      en: "Founder",
      zh: "创始人"
    },
    image: "/Junxiao Yi.png"
  },
  {
    id: 102,
    name: "Yue Ma",
    position: {
      en: "Vice President, Founder",
      zh: "副主席，创始人"
    },
    image: "/Yue Ma.png"
  },
  {
    id: 103,
    name: "Lingqiao Tang",
    position: {
      en: "Board Member",
      zh: "委员会成员"
    },
    image: "/Venessa Tang.png"
  },
  {
    id: 104,
    name: "Brandon Shen",
    position: {
      en: "Board Member",
      zh: "委员会成员"
    },
    image: "/Brandon Shen.png"
  },
  {
    id: 105,
    name: "Shawn Tian",
    position: {
      en: "Board Member",
      zh: "委员会成员"
    },
    image: "/Shawn Tian.png"
  },
  {
    id: 106,
    name: "Ciping Wu",
    position: {
      en: "Board Member",
      zh: "委员会成员"
    },
    image: "/Ciping Wu.png"
  },
  {
    id: 107,
    name: "Nian Zhao",
    position: {
      en: "Board Member",
      zh: "委员会成员"
    },
    image: "/Nian Zhao.png"
  },
  {
    id: 108,
    name: "Miles Guo",
    position: {
      en: "Committee Secretary",
      zh: "秘书"
    },
    image: "/Miles Guo.png"
  },
  {
    id: 109,
    name: "ChengCheng Zhao",
    position: {
      en: "Committee Observer",
      zh: "观察员"
    },
    image: "/Chengcheng Zhao.png"
  },
  {
    id: 110,
    name: "Ruicong Ni",
    position: {
      en: "Committee Observer",
      zh: "创始人，观察员"
    },
    image: "/Ruicong Ni.png"
  }
];

// All committee terms, newest first. Exactly one term should have current: true.
export const committeeTerms = [
  {
    id: '2026-2028',
    label: '2026–2028',
    label_cn: '2026–2028届',
    current: true,
    members: committee2026Members,
  },
  {
    id: '2024-2026',
    label: '2024–2026',
    label_cn: '2024–2026届',
    current: false,
    members: committee2024Members,
  },
];

const currentTerm = committeeTerms.find(t => t.current) || committeeTerms[0];

// Backward-compatible named exports
export const committee2026 = committee2026Members;
export const committee2024 = committee2024Members;

// Used for admin-privilege checks — only the current term grants access
export const committeeMembers = currentTerm.members;
